exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\nbody {\n    background-color: #e6ecf7;\n}\n\n.example {\n    display: inline-block;\n    padding: 20px;\n}\n\n.arc text {\n    font: 10px sans-serif;\n    text-anchor: middle;\n}\n  \n.arc path {\n    stroke: #fff;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/postcss-loader?{"ident":"postcss"}!/Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = 2